/* assets/component-card-switcher.js */

/*
 * Belka z kodem rabatowym na karcie (snippets/promo-code-line.liquid) opisuje
 * KONKRETNY produkt. Pojemności to osobne produkty z własnym metapolem
 * custom.promo_code, a cache przełącznika (data-cv) kodu nie zawiera — więc po
 * przełączeniu belkę dociągamy z sections/promo-line-lazy.liquid przez Section
 * Rendering API. Kolejność jest wymogiem: najpierw czyścimy slot, dopiero potem
 * pytamy serwer. Inaczej pojemność bez kodu pokazywałaby belkę poprzedniej.
 *
 * Cache trzymany na window, nie przez const: ten plik emituje sześć sekcji
 * (featured-collection-carousel, main-collection, main-search, main-wishlist,
 * related-products, discount-collection), a strona główna ma trzy aktywne sekcje
 * featured-collection-carousel — czyli trzy tagi <script> i trzy wykonania tego
 * samego kodu w jednym globalu. Deklaracja leksykalna wywaliłaby drugie i trzecie
 * wykonanie na SyntaxError. Przy okazji trzy wykonania dzielą jeden cache.
 * Wzorzec fetchowania z cache: assets/lazy-sections.js:50-63.
 */
var promoLineCache = window.__promoLineCache || (window.__promoLineCache = new Map()); // url sekcji -> Promise<string>

function fetchPromoLine(productUrl) {
  const endpoint = productUrl.split('?')[0].split('#')[0] + '?section_id=promo-line-lazy';
  if (!promoLineCache.has(endpoint)) {
    promoLineCache.set(
      endpoint,
      fetch(endpoint)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .catch(function (err) {
          promoLineCache.delete(endpoint); // kolejne przełączenie ma szansę spróbować ponownie
          throw err;
        })
    );
  }
  return promoLineCache.get(endpoint);
}

function loadPromoLine(slot, productUrl, token) {
  // Brak URL-a: slot został już wyczyszczony przez wywołującego i taki zostaje.
  // To zamierzone — nie przywracaj tu poprzedniej treści, bo opisywałaby inny produkt.
  if (!productUrl) return;
  fetchPromoLine(productUrl)
    .then(function (html) {
      // Token odsiewa spóźnione odpowiedzi: przy szybkim 33 -> 50 -> 33 wygrywa
      // ostatnie kliknięcie, nie ta odpowiedź, która wróciła jako druga.
      if (slot.__promoToken !== token || !slot.isConnected) return;
      const wrap = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-lazy-wrap]');
      if (!wrap || wrap.hasAttribute('hidden')) return;
      slot.innerHTML = wrap.innerHTML;
    })
    .catch(function () {
      // Slot zostaje pusty — brak belki jest bezpieczniejszy niż belka nie tego produktu.
    });
}

document.addEventListener('click', function(e) {
  // Sprawdź czy kliknięto w nasz przycisk wariantu
  const btn = e.target.closest('.cvs-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  // Jeśli przycisk jest już aktywny, nic nie rób
  if (btn.classList.contains('active')) return;

  // Znajdź główny kontener karty produktu
  const card = btn.closest('hdt-card-product');
  if (!card) return;

  // --- POBIERANIE DANYCH Z PRZYCISKU ---
  const data = {
    id: btn.dataset.id,
    title: btn.dataset.title,
    url: btn.dataset.url,
    img: btn.dataset.img,
    imgHover: btn.dataset.imgHover,
    price: btn.dataset.price,
    comparePrice: btn.dataset.comparePrice
  };

  // --- ZMIANA STANU PRZYCISKÓW (UI) ---
  const wrapper = btn.closest('.card-variant-switcher');
  wrapper.querySelectorAll('.cvs-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  // --- BELKA Z KODEM RABATOWYM ---
  // Czyszczenie natychmiast, poza setTimeout: między kliknięciem a odpowiedzią
  // serwera karta nie może pokazywać kodu poprzedniej pojemności.
  const promoSlot = card.querySelector('[data-promo-slot]');
  if (promoSlot) {
    promoSlot.innerHTML = '';
    promoSlot.__promoToken = (promoSlot.__promoToken || 0) + 1;
    loadPromoLine(promoSlot, data.url, promoSlot.__promoToken);
  }

  // --- ANIMACJA (Opacity) ---
  const elementsToAnimate = [
    card.querySelector('.hdt-card-product__media'),
    card.querySelector('.hdt-card-product__title'),
    card.querySelector('.hdt-price-wrapp')
  ].filter(el => el); // filtrujemy null, jeśli czegoś nie znajdzie

  elementsToAnimate.forEach(el => el.classList.add('cvs-updating'));

  // Krótkie opóźnienie dla efektu wizualnego
  setTimeout(() => {
    
    // 1. PODMIANA ID DO KOSZYKA (Najważniejsze)
    // Szukamy formularza i inputu name="id"
    const form = card.querySelector('form[action*="/cart/add"]');
    if (form) {
      const inputId = form.querySelector('input[name="id"]');
      if (inputId) inputId.value = data.id;
      
      // Niektóre szablony mają też ukryty input name="product-id"
      const inputProdId = form.querySelector('input[name="product-id"]');
      if (inputProdId) inputProdId.value = data.id; // Tutaj teoretycznie powinno być Product ID, ale Variant ID często też działa w Shopify, zależnie od logiki theme'u. 
      // W Shopify 'id' w formularzu to ZAWSZE Variant ID.
    }

    // 2. PODMIANA OBRAZKA
    if (data.img) {
      const mainImg = card.querySelector('.hdt-card-product__media--main');
      if (mainImg) {
        mainImg.src = data.img;
        mainImg.srcset = data.img; // Resetujemy srcset, żeby przeglądarka nie wymusiła starego
      }
    }
    // Podmiana hovera (opcjonalnie, jeśli jest w danych)
    if (data.imgHover) {
      const hoverImg = card.querySelector('.hdt-card-product__media--hover');
      if (hoverImg) {
        hoverImg.src = data.imgHover;
        hoverImg.srcset = data.imgHover;
      }
    }

    // 3. PODMIANA TYTUŁU I LINKÓW
    const titleEl = card.querySelector('.hdt-card-product__title');
    if (titleEl) {
      titleEl.textContent = data.title;
      titleEl.href = data.url;
    }
    // Podmieniamy też link na obrazku
    const imgLink = card.querySelector('.hdt-card-product__media-wrapp');
    if (imgLink) imgLink.href = data.url;

    // 4. PODMIANA CENY
    const priceEl = card.querySelector('.hdt-price .hdt-money');
    if (priceEl) priceEl.innerHTML = data.price;

    const comparePriceEl = card.querySelector('.hdt-compare-at-price .hdt-money');
    const compareWrapper = card.querySelector('.hdt-compare-at-price');
    
    if (data.comparePrice) {
      // Jeśli jest cena promocyjna
      if (comparePriceEl) comparePriceEl.innerHTML = data.comparePrice;
      if (compareWrapper) compareWrapper.classList.remove('hdt-hidden');
    } else {
      // Jeśli nie ma promocji, ukrywamy przekreśloną cenę
      if (compareWrapper) compareWrapper.classList.add('hdt-hidden');
    }

    // KONIEC ANIMACJI
    elementsToAnimate.forEach(el => el.classList.remove('cvs-updating'));

  }, 200);
});